import { useQuery } from '@tanstack/react-query';

import { useAppSelector } from 'store';

import { $apiWithoutClient } from 'modules/global';

import { IOlympicResults } from '..';

export const useOlympicResults = (id?: string) => {
  const isAuthenticated = useAppSelector(({ authModal }) => authModal.isAuthenticated.status);

  const { data, ...args } = useQuery<{ results: IOlympicResults[] }>({
    queryKey: ['olympic-results', id],
    queryFn: async () => {
      const { data } = await $apiWithoutClient.get('/olympic/olympic-stats', { params: { olympic_id: id } });

      return { results: data };
    },
    enabled: isAuthenticated
  });

  return { ...data, ...args };
};
